
import React, { Component} from 'react';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';

import { MispariForm } from './';
import Heading from '../Heading/Heading';
import { products } from '../../services';
import PhoneNumberFormat from '../../lib/phoneNumber/PhoneNumberFormat';


class ManageMispari extends Component {
  constructor(){
    super()
    this.state = {
      data: '',
    };
  }

  componentDidMount(){
    const { rest } = this.props;
    const ProductId = rest.computedMatch.params.userProductId;
    products.getProduct(ProductId)
      .then((res) => {
        this.setState({
          data: res.body.data.userProduct.Data,
        });
      });
    products.getMispari(ProductId)
    .then((res) => {
    this.props.setMispari(res.body.data.Mispari);
    });
  }
  render(){
    const { data } = this.state
    const { rest } = this.props

    return(
      <div className="service-action" >
        <div className="card card-service-action">
          <div className="card-block">
            {Heading("Mispari",PhoneNumberFormat(data.phoneNumber))}
            <MispariForm rest={rest} phoneNumber={PhoneNumberFormat(data.phoneNumber)} />
          </div>
        </div>
      </div>
    )
  }

}
const viewMapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {
    setMispari: (mispari) => {
      dispatch(
        {
          type: 'SET_MISPARI',
          mispari: mispari,
        },
      );
    },
  };
};

ManageMispari = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(ManageMispari);
export default ManageMispari;



// WEBPACK FOOTER //
// ./src/components/Mispari/ManageMispari.js